<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004554') }}</span>
            <span class="basic_txt">{{ detailsData.subPackageCode }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004555') }}</span>
            <span class="basic_txt">{{ detailsData.statusText }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000601') }}</span>
            <span class="basic_txt">{{ detailsData.skuQuantity }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004556') }}</span>
            <span class="basic_txt">{{ detailsData.productQuantity }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--明细信息-->
    <div class="basic_information_box">
      <div class="table_box">
        <Table
          highlight-row
          border
          max-height="650"
          :loading="tableLoading"
          :columns="tableColumns"
          :data="tableData">
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getDataSetBatchList, setConfigCharacters, getEnumName} from "@/utils/common";

export default {
  name: "supplierOrderDetails",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 6,
      detailsData: {},
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004368'),
          key: 'index',
          align: 'center',
          width: 80,
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004551'),
          key: 'pictureUrl',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            return v.tableImg(h, params, 'path');
          }
        },
        {
          title: `${setConfigCharacters(false)}SKU`,
          key: 'ymsSku',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let ymsSku = params.row.ymsSku;
            let isNeedCustomization = params.row.isNeedCustomization;
            let originalYmsSku = params.row.originalYmsSku;
            return h('div', [
              h('p', ymsSku),
              isNeedCustomization === 1 ? h('p', {class: 'flex align-items-center'}, [
                h('span', {class: 'themeColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004552') + originalYmsSku + ')'),
                h('Tooltip', {
                  props: {
                    transfer: true,
                    maxWidth: 450,
                    content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004306'),
                    placement: 'top'
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'md-alert',
                      size: 17
                    },
                    class: 'cursor ml5 themeColor'
                  })
                ])
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000216'),
          key: 'remark',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          minWidth: 100,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004553'),
          key: 'outOfStockInfo',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            let abnormalStatus = params.row.abnormalStatus; // 异常状态 1.正常 2.缺货
            let estimateArrivalOfGoodsTime = params.row.estimateArrivalOfGoodsTime ?
              v.$uDate.dealTime(params.row.estimateArrivalOfGoodsTime) : null;
            let goodsStatus = params.row.goodsStatus; //货品状态 1.正常 2.停售
            if (abnormalStatus === 2) {
              if (goodsStatus === 1) {
                return h('div', {class: 'crimsonRedColor text-align-left'}, [
                  h('p', {class: 'mt3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004364')),
                  estimateArrivalOfGoodsTime ? h('p', {class: 'crimsonRedColor mt3 flex'}, [
                    h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004361')),
                    h('span', estimateArrivalOfGoodsTime)
                  ]) : '',
                ]);
              } else if (goodsStatus === 2) {
                return h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000084'));
              }
            } else {
              return h('p', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000524'),
          key: 'outOfStockQuantity',
          minWidth: 100,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000589'),
          key: 'productGoodsWeight',
          minWidth: 100,
          align: 'center'
        }
      ],
      tableData: [],
      enumData: []
    };
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['YmsSubPackageInfoIsOutPackageStatusCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.where = this.$route.query.where ? this.$route.query.where : null;
      this.getDetailsData();
    },
    // 返回列表
    goBackBtn() {
      switch (this.where) {
        // 拣货--生成拣货单
        case 'generateOrderList':
          this.$router.push({
            path: '/generateOrderDetails',
            query: {
              ymsPackageId: this.$route.query.ymsPackageId,
              where: 'generateOrderList'
            }
          });
          break;
        // 组装加工---查看出库单详情
        case 'assembleGeneratePickingList':
          this.$router.push({
            path: '/assembleGeneratePickingDetails',
            query: {
              ymsPackageId: this.$route.query.ymsPackageId,
              where: 'assembleGeneratePickingList'
            }
          });
          break;
        // 云卖订单--云卖订单详情
        default:
          this.$router.push({
            path: '/orderListDetails',
            query: {
              ymsPackageId: this.$route.query.ymsPackageId
            }
          });
      }
    },
    // 获取供应商订单详情的数据
    getDetailsData() {
      let v = this;
      v.tableLoading = true;
      v.axios.get(api.get_ymsSubPackageInfo + `${v.$route.query.ymsSubPackageId}`).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          data.statusText = getEnumName(v.enumData, 'YmsSubPackageInfoIsOutPackageStatusCoreEnum', data.outPackageStatus, 'number');
          v.detailsData = data;
          v.tableData = data.subPackageGoods;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
